// extracted by mini-css-extract-plugin
module.exports = {"inner":"_0a3a94f455--inner--U8IF1"};